import { React, useEffect, useState } from "react";
import "./testiReview.css";
export const CheckboxReview = (props) => {
  const productId = props.id;
  const idProUsed = "proUsed_";
  const [arrayProsUsed, setarrayProsUsed] = useState([]);

/**
 * If the checkbox is checked, add the value to the array. If the checkbox is unchecked, remove the
 * value from the array.
 */
  const onChange = (e) => {
    let checked = e.target.checked;
    let value = e.target.value;
    if (checked) {
      setarrayProsUsed((oldArray) => [...oldArray, parseInt(value)]);
    } else {
      let tmpArry = arrayProsUsed;
      for (var i = 0; i < tmpArry.length; i++) {
        if (tmpArry[i] === parseInt(value)) {
          tmpArry.splice(i, 1);
        }
      }
      //clear all the array to send newOne omitting any error
      setarrayProsUsed(null);
      document.getElementById(idProUsed + productId).value = null;
      setarrayProsUsed(tmpArry);
      document.getElementById(idProUsed + productId).value = tmpArry;
    }
  };
  
  useEffect(() => {
    document.getElementById(idProUsed + productId).value = arrayProsUsed;
  }, [arrayProsUsed]);
  return (
    <>
      Used For:
      <br />
      <table>
        <tbody>
          <tr>
            <td className="review_checkbox">
              <input
                type="checkbox"
                name="Centerpieces"
                id="Centerpieces"
                value="1"
                onChange={onChange}
                className="global-checkbox--input"
              />
              <label htmlFor="Centerpieces" className="global-checkbox--label form-label--checkbox">Centerpieces</label>
            </td>
            <td className="review_checkbox">
              <input
                type="checkbox"
                name="Bridal Bouquet"
                id="Bridal Bouquet"
                value="2"
                onChange={onChange}
                className="global-checkbox--input"
              />
              <label htmlFor="Bridal Bouquet"className="global-checkbox--label form-label--checkbox">Bridal Bouquet</label>
            </td>
            <td className="review_checkbox">
              <input
                type="checkbox"
                name="Bridesmaid's Bouquets"
                id="Bridesmaid's Bouquets"
                value="3"
                onChange={onChange}
                className="global-checkbox--input"
              />
              <label htmlFor="Bridesmaid's Bouquets" className="global-checkbox--label form-label--checkbox">Bridesmaid's Bouquets</label>
            </td>
            <td className="review_checkbox">
              <input
                type="checkbox"
                name="Corsages"
                id="Corsages"
                value="4"
                onChange={onChange}
                className="global-checkbox--input"
              />
              <label htmlFor="Corsages" className="global-checkbox--label form-label--checkbox">Corsages</label>
            </td>
            <td className="review_checkbox">
              <input
                type="checkbox"
                name="Boutonnieres"
                id="Boutonnieres"
                value="5"
                onChange={onChange}
                className="global-checkbox--input"
              />
              <label htmlFor="Boutonnieres" className="global-checkbox--label form-label--checkbox">Boutonnieres</label>
            </td>
            <td className="review_checkbox">
              <input
                type="checkbox"
                name="Other"
                id="Other"
                value="6"
                onChange={onChange}
                className="global-checkbox--input"
              />
              <label htmlFor="Other" className="global-checkbox--label form-label--checkbox">Other</label>
            </td>
          </tr>
        </tbody>
      </table>
      <input
        type="hidden"
        name={idProUsed + productId}
        id={idProUsed + productId}
      />
    </>
  );
};
export default CheckboxReview;
